import React from 'react';
import * as Fa from 'react-icons/fa';

const MenuRoute = [
  {
    title: 'Fulfillment',
    path: '',
    icon: <Fa.FaDropbox size={18} />,
    isActive: 'fulfillment',
    isDropdown: true,
    child: [
      {
        title: 'Delivery Plan',
        path: '/delivery/plan',
        isActive: 'delivery-plan',
        icon: <Fa.FaRegListAlt size={15} />,
      },
      {
        title: 'Fulfillment',
        path: '/delivery/fulfillment',
        isActive: 'fulfillment',
        icon: <Fa.FaDropbox size={15} />,
      },
    ],
  },
  {
    title: 'Receiving',
    path: '',
    icon: <Fa.FaClipboardList size={18} />,
    isActive: 'receiving',
    isDropdown: true,
    child: [
      {
        title: 'Receiving Plan',
        path: '/receiving/plan',
        isActive: 'receive-plan',
        icon: <Fa.FaTruckMoving size={15} />,
      },
      {
        title: 'Good Receipt',
        path: '/receiving/receive',
        isActive: 'receive',
        icon: <Fa.FaBoxes size={15} />,
      },
    ],
  },
  {
    title: 'Inventory',
    path: '/inventory/item-stock',
    icon: <Fa.FaClipboardList size={18} />,
    isActive: 'item-stock',
    isMaster: false,
    isDropdown: true,
    child: [
      {
        title: 'Item',
        path: '/inventory',
        isActive: 'item',
        icon: <Fa.FaThList size={15} />,
      },
      {
        title: 'Item Stock',
        path: '/inventory/item-stock',
        isActive: 'item-stock',
        icon: <Fa.FaTruckMoving size={15} />,
      },
      {
        title: 'Stockopname',
        path: '/inventory/stockopname',
        isActive: 'stockopname',
        icon: <Fa.FaBoxes size={15} />,
      },
      {
        title: 'Stockmovement',
        path: '/inventory/stockmovement',
        isActive: 'stockmovement',
        icon: <Fa.FaBox size={15} />,
      },
    ],
  },

  {
    title: 'Laporan',
    path: '',
    icon: <Fa.FaFolder size={18} />,
    isActive: 'report',
    isDropdown: true,
    child: [
      {
        title: 'Laporan Stock Log',
        path: '/report/stock/log',
        isActive: 'stock',
        icon: <Fa.FaListUl size={15} />,
      },
    ],
  },
  {
    title: 'User Management',
    path: '/user',
    icon: <Fa.FaUserFriends size={18} />,
    isActive: 'user_management',
    isMaster: true,
  },
];

export default MenuRoute;
